export default __webpack_public_path__ + "static/media/new-text-disabled.eb6cb993.svg";